<template>
	<section role="main" class="content-body">
		<header class="page-header">
			<h2>宿舍簡介</h2>
			<div class="right-wrapper">
				<ol class="breadcrumbs">
					<li><router-link to="/index"> <i class="fa fa-home"></i> </router-link></li>
					<li>宿舍簡介</li>
				</ol>
			</div>
		</header>
		<section class="panel">
			<div class="panel-body">
				<div class="row form-group" v-if="isAdmin('stay')">
					<div class="col-md-12 text-right form-inline">
						<button class="btn btn-danger m-xs" @click="isEdit = true;" >編輯簡介</button>
					</div>
				</div>
				<div class="row form-group">
					<div class="col-md-12 form-group">
						<ckeditor v-if="isEdit" v-model="introduct.introductContent" :config="editorConfig"></ckeditor>
						<div v-else style="min-height: 310px;" v-html="introduct.introductContent"></div>
					</div>
				</div>
				<div class="row form-group">
					<div class="col-md-12 form-group" v-if="isEdit">
						<label class="col-xs-6 col-md-3">附件上傳：</label>
						<label class="col-xs-6 col-md-3" for="introductFile">
							<div style="display:none;">
								<input type="file" id="introductFile" style="width: 100%" accept=".pdf,image/*" ref="introductFile" @change="headleFile($event)" multiple="multiple"/>
							</div>
							<a class="btn btn-default">請選擇檔案</a>
						</label>
					</div>
					<div class="col-md-12 form-group">
						<p v-for="(item, index) in introduct.fileList" :key="index">
							<span v-if="item.filePath">
								<a class="btn btn-link" @click="downloadFile(item)" style="color: #337ab7" target="_blank" >{{item.fileName}}</a>
								<a class="btn btn-link" v-if="isEdit" @click="deleteFile(item.id)" style="color: #FF0000"><i class="glyphicon glyphicon-trash"></i></a>
							</span>
              <span v-else>
                <a class="btn btn-link" disabled>{{item.fileName}}</a>
              </span>
							<span v-if="item.preview">
								<a :href="item.preview" target="_blank">
									<img class="img-fluid" :src="item.preview" alt="" style="width:200px;"/>
								</a>
							</span>
						</p>
					</div>
				</div>
				<div class="row form-group" v-if="isEdit">
					<div class="col-md-2 col-md-offset-3 form-group">
							<a @click="isEdit = false; init()" class="btn s_btn_g btn-block">返回</a>
						</div>
						<div class="col-md-2 form-group">
						</div>
						<div class="col-md-2 form-group">
							<a @click="saveEvent" class="btn btn-primary btn-block">儲存</a>
						</div>
				</div>
			</div>
		</section>

	</section>
</template>
<script>
import CKEditor from "@/ckeditor4";
export default {
	components: {
		ckeditor: CKEditor.component
	},
	data:()=>({
		editorConfig: {
			extraPlugins: ["colorbutton", "uploadimage"],
			filebrowserImageUploadUrl:"/api/Common/uploadEditorImage",
			height:500,
			toolbar: [
				["Source"],
				["Cut", "Copy", "Paste", "PasteText", "PasteFromWord"],
				["Undo", "Redo"],
				["RemoveFormat"],
				["NumberedList", "BulletedList"],
				["Outdent", "Indent"],
				["Blockquote"],
				["Link", "Unlink", "Anchor"],
				["Image", "Table", "HorizontalRule"],
				["SpecialChar"],
				"/",
				["Styles", "Format"],
				["Bold", "Italic", "Strike"],
				["TextColor", "BGColor"],
				["Maximize"],
				["About"]
			]
		},
		isEdit:false,
		uploadFiles:[],
		introduct:{},
		introductFileList:[],
		editorData: ""
	}),
	mounted(){
		this.init();
	},
	methods:{
		init(){
			let api = "/api/Introduct";
			this.$axios.get(api).then(resp => {
				this.introduct = resp.data.data;
				this.introduct.introductContent = this.htmlDecode(this.introduct.introductContent);
			});
		},
		downloadFile(fileItem){
			const api = "/api/Common/downloadNewsFile/";
			this.$axios.post(api, JSON.stringify({model:fileItem.filePath}), {
				headers: { "Content-Type": "application/json" },
				responseType: "blob"
			}).then(resp => {
				const url = window.URL.createObjectURL(new Blob([resp.data]));
				const link = document.createElement("a");
				link.href = url;
				link.setAttribute("download", fileItem.fileName);
				document.body.appendChild(link);
				link.click();
			});
		},
		headleFile(event) {
			let self = this
			if(event.target.files.length > 0){
				let fileList = event.target.files;
				for(let i=0; i < fileList.length; i++){
					let item = fileList[i];
					this.uploadFiles.push(item);

					let fileValue ={
						fileName:item.name,
						filePath:"",
						preview:null,
            id: this.introduct.fileList.length + 1
					};
					this.imgPreview(item).then(result =>{
						fileValue.preview = result;
            this.introduct.fileList.push(fileValue);
					})
				}
			}
		},
		saveEvent(){
			let formData = new FormData();
			for(let k in this.introduct){
				let v = this.introduct[k];
				if(k == "introductContent"){
					v = this.htmlEncode(v);
				}
				if(k == "fileList"){
					continue;
				}
				formData.append("introduct."+k, v);
			}
			for(let i=0; i< this.uploadFiles.length;i++){
				formData.append("introductFileList", this.uploadFiles[i]);
			}
			let api = "/api/Introduct/saveIntroduct";
			this.$axios.post(api, formData).then(resp => {
				if(resp.data.status == "success"){
					this.init();
					this.isEdit = false;
				}
			});
		},
		deleteFile(id){
      if(typeof(id) == "number"){
        this.introduct.fileList = this.introduct.fileList.filter(item => item.id != id);
      } else {
        let api = "/api/Introduct/deleteFile/"+id;
        this.$axios.delete(api).then(resp => {
          if(resp.data.status == "success"){
            this.init();
            this.isEdit = false;
          }
        });
      }
		}
	}
}
</script>
<style>
	.ck-editor__editable{
		min-height: 300px;
	}
</style>
